export { Spinner } from './spinner';
export type { SpinnerProps } from './spinner';
